<div class="modal-header">
   <h2 class="modal-title"> {{ "MC_CUSTOMERDETAILS_CREATING" | translate }} </h2>
   <telenet-icon class="modal-dismiss" name="close" (click)="modalRef.dismiss()"></telenet-icon>
</div>


<div class="modal-body">
   <div class="col-sm-12 validation-errors">
      <my-cloud-validation-errors [validationErrors]="validationErrors"></my-cloud-validation-errors>
   </div>

   @if (isCreating) {
   <my-cloud-custom-message [message]="'MC_REGISTER_AS_NEW_CUSTOMER_IS_CREATING' | translate">
   </my-cloud-custom-message>
   }

   @if (!isCreating) {
   <div class="content" [dynamicValidationsHeight]="validationErrors">
      <div class="d-flex">
         <div class="credentials-info col-sm-12">
            <div class="custom-card">
               <div class="custom-card-header">
                  <div class="title">
                     <span>{{'MC_CUSTOMERDETAIL_MAINTITLE_CREDENTIALS' | translate}}</span>
                     <span class="icon-tooltip">
                        <telenet-icon name="help" [ngbTooltip]="CUSTOMERDETAILS_LOGIN_INFORMATION" placement="top" container="body"></telenet-icon>
                        <ng-template #CUSTOMERDETAILS_LOGIN_INFORMATION>
                           <span [innerHTML]="'MC_CUSTOMERDETAILS_LOGIN_INFORMATION' | translate"></span>
                        </ng-template>
                     </span>
                  </div>
               </div>
               <div class="custom-card-body">
                  <div class="form-group row">
                     <label for="username" class="col-sm-4 col-form-label"><span [innerHTML]="'MC_USERNAME' | translate"></span> *</label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="username" name="username" [(ngModel)]="createCustomerCommand.username" autocomplete="off" />
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="newPassword" class="col-sm-4 col-form-label"><span [innerHTML]="'MC_NEW_PASSWORD' | translate"></span> *</label>
                     <div class="col-sm-8">
                        <my-cloud-password-input [id]="'newPassword'" [(value)]="createCustomerCommand.newPassword" [autocomplete]="'off'"></my-cloud-password-input>
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="repeatNewPassword" class="col-sm-4 col-form-label"><span [innerHTML]="'MC_MAILACC_LBL_REPEATPASSWORD' | translate"></span> *</label>
                     <div class="col-sm-8">
                        <my-cloud-password-input [id]="'repeatNewPassword'" [(value)]="createCustomerCommand.repeatNewPassword" [autocomplete]="'off'"></my-cloud-password-input>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="d-flex mt-3">
         <div class="invoice-info col-sm-12">
            <div class="custom-card">
               <div class="custom-card-header d-flex justify-content-between">
                  <span>{{'MC_CUSTOMERDETAIL_INVOICING' | translate}}</span>
               </div>
               <div class="custom-card-body">
                  <div class="form-group row">
                     <label for="invoiceFirstName" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVFIRSTNAME' | translate"></label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="invoiceFirstName" name="invoiceFirstName" [(ngModel)]="customerInvoiceModel.invoiceFirstName" />
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceLastName" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVNAME' | translate"></label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="invoiceLastName" name="invoiceLastName" [(ngModel)]="customerInvoiceModel.invoiceLastName" />
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceCompanyName" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVCOMPANY' | translate"></label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="invoiceCompanyName" name="invoiceCompanyName"
                           [(ngModel)]="customerInvoiceModel.invoiceCompanyName" />
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceStreet" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVADDRESS' | translate"></label>
                     <div class="col-sm-8">
                        <div class="d-flex gap-2 align-items-center">
                           <input type="text" class="form-control form-control-sm" id="invoiceStreet" name="invoiceStreet" [(ngModel)]="customerInvoiceModel.invoiceStreet" [readonly]="showAddressLookup" />
                           @if (showAddressLookup) {
                           <button data-testid="register-customer-btn-lookup" type="button" class="btn btn-telenet-light btn-address-lookup" (click)="openAddressLookup()">
                              <telenet-icon name="search"></telenet-icon>
                           </button>
                           }
                        </div>
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceZip" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVZIP' | translate"></label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="invoiceZip" name="invoiceZip" [(ngModel)]="customerInvoiceModel.invoiceZip" [readonly]="showAddressLookup" />
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceLocation" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVLOCATION' | translate"></label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="invoiceLocation" name="invoiceLocation" [(ngModel)]="customerInvoiceModel.invoiceLocation" [readonly]="showAddressLookup" />
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceCountryCode" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_ADMCOUNTRY' | translate"></label>
                     <div class="col-sm-8">
                        <select id="invoiceCountryCode" class="form-control form-control-sm" [ngModel]="customerInvoiceModel.invoiceCountryCode"
                           (ngModelChange)="invoiceCountryCodeChanged($event)">
                           @for ( country of countries; track  country) {
                           <option [value]="country.code">
                              <span>{{ country.description }}</span>
                           </option>
                           }
                        </select>
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceLanguageCode" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_ADMLANGUAGE' | translate"></label>
                     <div class="col-sm-8">
                        <select id="type" class="form-control form-control-sm" [(ngModel)]="customerInvoiceModel.invoiceLanguageCode">
                           @for (language of languages; track language) {
                           <option [value]="language.code">
                              <span>{{ language.code | enumTranslation: 'MC_LANGUAGE' | translate }}</span>
                           </option>
                           }
                        </select>
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoicePhone" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVPHONE' | translate"></label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="invoicePhone" name="invoicePhone" [(ngModel)]="customerInvoiceModel.invoicePhone" />
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceEmail" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVEMAIL' | translate"></label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="invoiceEmail" name="invoiceEmail" [(ngModel)]="customerInvoiceModel.invoiceEmail" />
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceVatTypeId" class="col-sm-4 col-form-label" [innerHTML]="'MC_VAT_TYPE' | translate"></label>
                     <div class="col-sm-8">
                        <select id="invoiceVatTypeId" class="form-control form-control-sm" [(ngModel)]="customerInvoiceModel.invoiceVatTypeId" (change)="onChangeVatTypeId()">
                           @for (type of invoicingVatTypes; track type) {
                           <option [value]="type.id">
                              <span>{{ type.textFragmentCode | translate }}</span>
                           </option>
                           }
                        </select>
                     </div>
                  </div>
                  <div class="form-group row">
                     <label for="invoiceVat" class="col-sm-4 col-form-label" [innerHTML]="invoiceVatLabel | translate"> </label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="invoiceVat" name="invoiceVat" [(ngModel)]="customerInvoiceModel.invoiceVat" />
                     </div>
                  </div>
                  @if (showPeppol) {
                  <div class="form-group row">
                     <label for="peppolId" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVPEPPOLID' | translate"></label>
                     <div class="col-sm-8">
                        <div class="input-group input-group-sm">
                           @if (customerInvoiceModel.invoiceCountryCode) {
                           <div class="input-group-prepend">
                              @if (isBeCountry) {

                                 <select id="peppolIdentificationScheme" name="peppolIdentificationScheme" class="form-control form-control-sm"
                                    [(ngModel)]="customerInvoiceModel.peppolIdentificationScheme">
                                    @for (scheme of peppolIdentificationSchemes; track scheme) {
                                       <option [value]="scheme">{{scheme}}</option>
                                    }
                                 </select>
                              
                              } @else {

                                 <input type="text" class="input-group-text" id="peppolIdentificationScheme" name="peppolIdentificationScheme"
                                    [(ngModel)]="customerInvoiceModel.peppolIdentificationScheme" />
                              
                              }
                              
                           </div>
                           }
                           <input type="text" class="form-control form-control-sm" id="peppolId" name="peppolId" [(ngModel)]="customerInvoiceModel.peppolId" />
                           @if (customerInvoiceModel.peppolIdentificationScheme) {
                           <div class="input-group-append">
                              <span class="input-group-text">{{customerInvoiceModel.peppolIdentificationScheme | enumTranslation: 'MC_PEPPOL_IDENTIFICATION_SCHEME' |
                                 translate}}</span>
                           </div>
                           }
                        </div>
                     </div>
                  </div>
                  }
                  @if (showPeppol) {
                  <div class="form-group row">
                     <label for="peppolBackupEmail" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVPEPPOLBACKUPEMAIL' | translate"></label>
                     <div class="col-sm-8">
                        <input type="text" class="form-control form-control-sm" id="peppolBackupEmail" name="peppolBackupEmail"
                           [(ngModel)]="customerInvoiceModel.peppolBackupEmail" />
                     </div>
                  </div>
                  }
               </div>
            </div>
         </div>
      </div>

   </div>
   }
</div>
<div class="modal-footer">
   <button type="button" class="btn" (click)="modalRef.dismiss()">
      {{ "MC_CANCEL" | translate }}
   </button>

   @if (isCreating) {
   <button type="button" class="btn btn-sm btn-telenet" (click)="checkPush()">
      <span>Check Status</span>
   </button>
   }
   @if (!isCreating) {
   <button type="button" class="btn btn-telenet" (click)="save()">
      {{ "MC_SAVE" | translate }}
   </button>
   }
</div>